import { render, staticRenderFns } from "./AVSettings.vue?vue&type=template&id=e127fffc&"
import script from "./AVSettings.vue?vue&type=script&lang=js&"
export * from "./AVSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports